import { Box, Typography, Button } from "@mui/material";
import { useSnackbar } from "../../../../Components/SnackBar";
import { soonBadge } from "../../styles/styles";
import { useTranslation } from "react-i18next";

export default function InviteContent({
  modalPosition,
  isBelowMd,
  sidebarData,
}) {
  const snackbar = useSnackbar();
  const { t, i18n } = useTranslation("bottom-menu-and-settings");
  const dynamicLinks = sidebarData?.inviteLinks || {};
  const language = i18n.language;
  const inviteLinks = [
    {
      label: t("inviteLinkLabels.general"),
      link: dynamicLinks.general + `-${language}`,
      soon: true,
    },
    {
      label: t("inviteLinkLabels.member"),
      link: dynamicLinks.member + `-${language}`,
      soon: false,
      soon: false,
    },
    {
      label: t("inviteLinkLabels.supplier"),
      link: dynamicLinks.supplier + `-${language}`,
      soon: false,
    },
  ];

  const handleCopyLink = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        snackbar(t('user_copy_invite_link'));
      })
      .catch((err) => {
        snackbar("Failed to copy link to clipboard!");
        console.error("Failed to copy: ", err);
      });
  };

  const webStyling = {
    position: "absolute",
    top: `${modalPosition.top - 145}px`,
    left: `280px`,
    bgcolor: "background.paper",
    p: "24px",
    height: "auto",
    borderRadius: "12px",
    minWidth: "300px",
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: "50%",
      left: "-12px",
      transform: "translateY(50%)",
      width: 0,
      height: 0,
      borderTop: "16px solid transparent",
      borderBottom: "16px solid transparent",
      borderRight: "16px solid white",
    },
  };

  const mobileStyling = {
    display: "flex",
    flexDirection: "column",
  };

  return (
    <Box sx={isBelowMd ? mobileStyling : webStyling}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        {inviteLinks.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
            }}
          >
            <Box>
              <Typography
                color="rgba(62, 63, 76, 1)"
                sx={{
                  mb: "8px",
                  fontWeight: 400,
                  fontSize: "15px",
                  textTransform: "capitalize",
                }}
              >
                {item.label}
              </Typography>
              {item.soon ? (
                <Box sx={soonBadge}>{t("soon")}</Box>
              ) : (
                <a href={item.link}>
                  <Typography
                    color="rgba(0, 85, 70, 1)"
                    sx={{
                      fontWeight: 500,
                      fontSize: "12px",
                      wordBreak: "break-all",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textDecoration: "underline",
                    }}
                  >
                    {item.link}
                  </Typography>
                </a>
              )}
            </Box>
            {item.soon ? (
              <></>
            ) : (
              <Button onClick={() => handleCopyLink(item.link)}>
                <img src="/icons/copy-icon.svg" alt="copyall-sign" />
              </Button>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
